import UIStore from 'states/globalStore'
import serviceConnect from './axios-connect'
import backendStringConstants from './backendStringConstants'

const resetGlobalStore = () => {
  UIStore.update(s => {
    /* eslint-disable */
    s.userProfile = null
    s.siteMap = null
    s.selectedSite = null
    /* eslint-enable */
  })
}

function onLogout(history) {
  return serviceConnect
    .post('/logout/')
    .then(() => {
      history.push('/login?redirect=true')
      if (localStorage) {
        localStorage.removeItem(backendStringConstants.API_URL)
        localStorage.removeItem(backendStringConstants.WS_API_URL)
        localStorage.removeItem('site')
      }
      resetGlobalStore()
    })
    .catch(() => {
      resetGlobalStore()
    })
}

export default onLogout
